import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Loading } from '@tcc-online/common-components';

import { AuthActions } from '../../../actions';
import { SIGN_IN_PATH } from '../../../constants/route.constants';
import { STATE_FAIL, STATE_LOADING } from '../../../constants/state.constants';
import { AppState } from '../../../reducers/root.reducer';
import AuthSelectors from '../../../selectors/AuthSelectors';
import { Base64 } from 'js-base64';

export default function SignInTokenPage() {
    const { status, isLoggedIn } = useSelector(mapState);
    const { token, params } = useParams<{ token: string; params?: string }>();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (status === STATE_LOADING) {
            return;
        }

        if (!token || status === STATE_FAIL) {
            navigate(SIGN_IN_PATH, { replace: true, relative: 'path' });
            return;
        }

        if (isLoggedIn) {
            dispatch(AuthActions.logout());
        }

        dispatch(
            AuthActions.loginWithToken(
                token,
                params ? Base64.decode(params) : null,
            ),
        );
        navigate(SIGN_IN_PATH, { replace: true, relative: 'path' });
    }, [dispatch, token, history, isLoggedIn, status]);

    return <Loading isLoading isTransparent={false} />;
}

function mapState(state: AppState) {
    return {
        status: AuthSelectors.getLoginWithTokenStatus(state),
        isLoggedIn: AuthSelectors.isLoggedIn(state),
    };
}
